import { initializeApp } from "firebase/app";
import { appConfig } from "./config";

export const firebaseApp = initializeApp(appConfig.firebase);
